import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../css/ofertas.css";
import { ENDPOINTS } from "../config/api";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const [documento, setDocumento] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Para 2FA
  const [userId2FA, setUserId2FA] = useState(null);
  const [code2FA, setCode2FA] = useState("");
  const [mfaMessage, setMfaMessage] = useState("");

  const navigate = useNavigate();
  const { token, login } = useContext(AuthContext);

  useEffect(() => {
    if (token) {
      navigate("/session/dashboard");
    }
  }, [token, navigate]);

  // ---------------------------------------------------
  // LOGIN NORMAL + DETECCIÓN DE 2FA ACTIVADO
  // ---------------------------------------------------
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!documento || !password) {
      setError("Por favor ingresa usuario y contraseña");
      return;
    }

    try {
      const res = await fetch(ENDPOINTS.login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ documento, password }),
      });

      const data = await res.json();
      console.log("Respuesta del servidor:", data);

      // ❌ Error normal (usuario/contraseña)
      if (!data.success) {
        setError(data.message);
        return;
      }

      // 🔐 Si requiere 2FA
      if (data.require_2fa) {
        setUserId2FA(data.id); // ⚠ Debe coincidir con PHP
        setMfaMessage("Se envió un código a tu correo electrónico");

        // Abrir modal
        const modal = new bootstrap.Modal(
          document.getElementById("mfaModalLogin")
        );
        modal.show();
        return;
      }

      // ✅ Login normal sin 2FA
      login(data); // guardamos token y user en Context
      navigate("/session/dashboard");

    } catch (err) {
      console.error("Error en fetch:", err);
      setError("Error en el servidor");
    }
  };

  // ---------------------------------------------------
  // VALIDAR CÓDIGO 2FA
  // ---------------------------------------------------
  const handleVerify2FA = async () => {
    if (!code2FA) {
      setMfaMessage("Debes ingresar el código recibido");
      return;
    }

    try {
      const res = await fetch(ENDPOINTS.verify2FA_login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: userId2FA, // ⚠ Debe coincidir con verify_2fa.php
          code: code2FA,
        }),
      });

      const data = await res.json();
      console.log("Respuesta verify 2FA:", data);

      if (!data.success) {
        setMfaMessage(data.message || "Código incorrecto");
        return;
      }

      // ✔ Código correcto → se recibe token y user
      login(data);

      // Cerrar modal
      const modalEl = document.getElementById("mfaModalLogin");
      const modal = bootstrap.Modal.getInstance(modalEl);
      modal.hide();

      navigate("/session/dashboard");

    } catch (err) {
      console.error(err);
      setMfaMessage("Error en el servidor");
    }
  };

  return (
    <div className="container mb-5 mt-5 p-5" style={{ maxWidth: "600px" }}>
      <p className="text-center mt-5">Crea tu hoja de vida y forma parte de Presencia.</p>

      <form onSubmit={handleLogin} className="card p-4 shadow-sm">
        {error && <div className="alert alert-danger">{error}</div>}

        {/* DOCUMENTO */}
        <div className="mb-3">
          <label className="form-label">Documento de identidad</label>
          <input
            type="text"
            className="form-control"
            placeholder="Número de documento"
            value={documento}
            onChange={(e) => setDocumento(e.target.value)}
          />
        </div>

        {/* CONTRASEÑA */}
        <div className="mb-3">
          <label className="form-label">Contraseña</label>
          <input
            type="password"
            className="form-control"
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {/* BOTÓN LOGIN */}
        <button type="submit" className="btn btn-outline-pink w-100 mb-2">
          Iniciar sesión
        </button>

        <div className="text-center mb-3">
          <a href="/forgotPassword" className="text-dark">¿Olvidaste tu contraseña?</a>
        </div>

        <hr />

        <div className="text-center">
          <button
            type="button"
            className="btn btn-outline-purple fw-bold"
            onClick={() => navigate("/register")}
          >
            Crear cuenta
          </button>
        </div>
      </form>

      {/* ------------------------------------------------------- */}
      {/* MODAL DE VERIFICACIÓN 2FA */}
      {/* ------------------------------------------------------- */}
      <div className="modal fade" id="mfaModalLogin" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Verificación en dos pasos</h5>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              {mfaMessage && <div className="alert alert-info">{mfaMessage}</div>}

              <label>Ingresa el código de 6 dígitos enviado a tu correo</label>
              <input
                type="text"
                className="form-control mt-2"
                value={code2FA}
                onChange={(e) => setCode2FA(e.target.value)}
                placeholder="123456"
              />
            </div>

            <div className="modal-footer">
              <button className="btn btn-outline-purple" data-bs-dismiss="modal">
                Cancelar
              </button>
              <button className="btn btn-outline-pink" onClick={handleVerify2FA}>
                Verificar Código
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;
